import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DetailedMessage from './DetailedMessage';

const DetailedMessageModal = ({ selectedMessage, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>SMS detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailedMessage selectedMessage={selectedMessage} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

DetailedMessageModal.propTypes = {
  selectedMessage: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedMessageModal;
